import { render } from "./EditNote.vue?vue&type=template&id=b05dd1aa"
import script from "./EditNote.vue?vue&type=script&lang=js"
export * from "./EditNote.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__